"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkAXBL3KEB_js = require('./chunk-AXBL3KEB.js');
var chunk356JBGIO_js = require('./chunk-356JBGIO.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var t = require('styled-components');
var faCircleInfo = require('@fortawesome/pro-solid-svg-icons/faCircleInfo');
var faCircleCheck = require('@fortawesome/pro-solid-svg-icons/faCircleCheck');
var faXmark = require('@fortawesome/pro-solid-svg-icons/faXmark');
var faHexagonExclamation = require('@fortawesome/pro-solid-svg-icons/faHexagonExclamation');
var faTriangleExclamation = require('@fortawesome/pro-solid-svg-icons/faTriangleExclamation');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);

var P=t.css`
  background-color: var(--color-pink-50, #fff7fb);
  border-color: var(--color-pink-600, #dd2270);

  > ${chunkLXX3SSRV_js.b} {
    color: var(--color-pink-600, #dd2270);
  }
`,$=t.css`
  background-color: var(--color-yellow-50, #fffae6);
  border-color: var(--color-yellow-600, #a66300);

  > ${chunkLXX3SSRV_js.b} {
    color: var(--color-yellow-600, #a66300);
  }
`,A=t.css`
  background-color: var(--color-blue-50, #f5faff);
  border-color: var(--color-blue-600, #0072d6);

  > ${chunkLXX3SSRV_js.b} {
    color: var(--color-blue-600, #0072d6);
  }
`,k=t.css`
  background-color: var(--color-green-50, #f2fcfc);
  border-color: var(--color-green-600, #108484);

  > ${chunkLXX3SSRV_js.b} {
    color: var(--color-green-600, #108484);
  }
`,y=t.css`
  flex-direction: column;
`,T=t.css`
  flex-direction: row;

  @media all and (max-width: 744px) {
    flex-direction: column;
  }
`,f=t__default["default"].button`
  align-items: center;
  background: none;
  border-radius: var(--border-radius-small, 6px);
  border: none;
  color: var(--color-neutral-700, #425678);
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  transition: ease-in-out color;
  width: 24px;
  margin-left: var(--spacing-regular, 16px);

  :hover {
    color: var(--color-neutral-800, #1f2f4f);
  }

  :focus {
    outline: 2px solid var(--color-neutral-800, #1f2f4f);
    outline-offset: -2px;
  }
`,d=t__default["default"](chunkAXBL3KEB_js.a)`
  align-self: flex-start;
  flex: 1 0 auto;
  flex-wrap: wrap;
`,u=t__default["default"](chunk356JBGIO_js.a).attrs({spacing:"small"})`
  min-width: 0;
`,m=t__default["default"](chunk2VCHSK65_js.d).attrs({weight:"bold"})`
  color: var(--color-neutral-800, #1f2f4f);
`,g=t__default["default"].div`
  display: flex;
  flex-grow: 1;
  gap: var(--spacing-regular, 16px);
  min-width: 0;

  ${({$size:r})=>r==="small"?y:T}
`,x=t__default["default"].div`
  align-items: flex-start;
  background-color: var(--color-neutral-50, #f7faff);
  border-color: var(--color-neutral-500, #8492ae);
  border-radius: var(--border-radius-small, 6px);
  border-style: solid;
  border-width: var(--border-width-small, 2px);
  color: var(--color-neutral-700, #425678);
  display: flex;
  padding: var(--spacing-regular, 16px);

  ${({$size:r})=>r==="small"?{"max-width":"744px"}:{"max-width":"1280px"}}

  > ${chunkLXX3SSRV_js.b} {
    color: var(--color-neutral-700, #425678);
    padding-top: var(--spacing-x-small);
    padding-right: var(--spacing-small);
  }

  ${r=>r.$variant==="danger"&&P}
  ${r=>r.$variant==="warning"&&$}
  ${r=>r.$variant==="info"&&A}
  ${r=>r.$variant==="success"&&k}
`;var R={danger:faHexagonExclamation.faHexagonExclamation,warning:faTriangleExclamation.faTriangleExclamation,info:faCircleInfo.faCircleInfo,success:faCircleCheck.faCircleCheck,default:faCircleInfo.faCircleInfo},e=({variant:r="default",onDismiss:i,size:s="large",children:b,...h})=>{let C=["danger","warning"].includes(r)?"alert":void 0,w=["info","default","success"].includes(r)?"polite":void 0;return jsxRuntime.jsxs(x,{$variant:r,role:C,"aria-live":w,$size:s,...h,children:[jsxRuntime.jsx(chunkLXX3SSRV_js.b,{size:"regular",icon:R[r]}),jsxRuntime.jsx(g,{$size:s,children:b}),i&&jsxRuntime.jsx(f,{onClick:i,"aria-label":"Close",children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{size:"regular",icon:faXmark.faXmark})})]})};e.Root=t__default["default"](e)``;e.Message=u;e.Title=m;e.Description=chunk2VCHSK65_js.d;e.Action=d;e.displayName="Alert";var F=e;

exports.a = F;
